import {NgModule} from '@angular/core';
import {FormDefinitionFormModule} from './form/formDefinitionForm.module';
import {FormDefinitionFieldModule} from './field/formDefinitionField.module';
import {FormDefinitionGroupModule} from './group/formDefinitionGroup.module';
import {FormDefinitionRuleModule} from "./rule/formDefinitionRule.module";

@NgModule({
    imports: [
        FormDefinitionFormModule,
        FormDefinitionGroupModule,
        FormDefinitionFieldModule,
        FormDefinitionRuleModule
    ]
})
export class FormDefinitionModule {
}
